import { shape, string } from "prop-types"
import QuestionForm from "./QuestionForm"

const NewQuestion = ({
  location: {
    state: { kind }
  },
  ...props
}) => {
  return <QuestionForm {...props} sectionHeaderKind={kind} />
}

NewQuestion.propTypes = {
  location: shape({
    state: shape({
      kind: string
    })
  })
}

export default NewQuestion
